import { ISelectOptions } from '@policoders/ds';

export enum TransactionType {
  '' = '',
  withdrawal = 'withdrawal',
  deposit = 'deposit',
  transfer = 'transfer',
}

export const TransactionOptions: ISelectOptions[] = [
  { label: 'Retirada', value: TransactionType.withdrawal },
  { label: 'Depósito', value: TransactionType.deposit },
];

export type TTransactionType = keyof typeof TransactionType;

export const TransactionTypeValidator = (input: TTransactionType) => {
  return input && (Object.values(TransactionType) as string[]).includes(input);
};
